import { Box, Stack, Typography, useTheme } from "@mui/material";
import { Construction } from "@mui/icons-material";
import { displayMessage } from "../constants/strings";

export function MaintenancePage() {
  const theme = useTheme();

  return (
    <Stack alignItems="center" pt={5} pb={10} sx={{ overflowY: "scroll" }}>
      <Construction
        sx={{
          fontSize: 180,
          color: theme.palette.primary.main,
          mb: 2,
        }}
      />
      <Box
        component="img"
        src="/empty-truck.webp"
        alt="Empty Daylight Truck"
        aria-hidden
        mt={-4}
        mb={-8}
        width={587}
      />
      <Stack alignItems="center" gap={3} mt={4}>
        <Typography
          variant="h3"
          component="h1"
          color={theme.palette.primary.main}
          fontWeight={700}
          textAlign="center"
        >
          {displayMessage.default.maintenanceTitle}
        </Typography>
        <Typography
          variant="h5"
          component="p"
          color="text.disabled"
          textAlign="center"
          fontSize="24px"
          maxWidth={500}
        >
          {displayMessage.default.maintenanceMessage}
        </Typography>
      </Stack>
    </Stack>
  );
}
